<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo" (click)="toHome()">
        <img class="logo-icon" [src]="logoFacturaSend">
        <!--
        <span class="logo-text secondary-text">FacturaSend</span>
        -->
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground"
     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <div class="h5 version">TenantID: {{ tenantId }} ({{environment.version}})</div>
        <!--
        <div class="h5 version">Versión: {{ environment.version }}</div>
        -->
        <div class="h4 username">{{ userData && userData.firstName !== null ? userData.firstName + ' (' + userData.role + ')' : ''}}</div>
        <div class="h5 email hint-text mt-8">{{ userData && userData.email !== null ? userData.email : '' }} </div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="{{ empresaService.logoUrl.asObservable() | async }}">
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

    <div class="panelSwitch" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    </div>

</div>
